import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type CreateAkteMutationVariables = Types.Exact<{
  caseId: Types.Scalars['ID']['input']
}>

export type CreateAkteMutation = { createAkte?: boolean | null }

export const CreateAkteDocument = gql`
  mutation CreateAkte($caseId: ID!) {
    createAkte(caseId: $caseId)
  }
`
export type CreateAkteMutationFn = Apollo.MutationFunction<
  CreateAkteMutation,
  CreateAkteMutationVariables
>

/**
 * __useCreateAkteMutation__
 *
 * To run a mutation, you first call `useCreateAkteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAkteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAkteMutation, { data, loading, error }] = useCreateAkteMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useCreateAkteMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAkteMutation, CreateAkteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAkteMutation, CreateAkteMutationVariables>(
    CreateAkteDocument,
    options
  )
}
export type CreateAkteMutationHookResult = ReturnType<typeof useCreateAkteMutation>
export type CreateAkteMutationResult = Apollo.MutationResult<CreateAkteMutation>
export type CreateAkteMutationOptions = Apollo.BaseMutationOptions<
  CreateAkteMutation,
  CreateAkteMutationVariables
>
